<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group>
        <b-form-input
          v-model="form.otp"
          :state="otpValid"
          type="text"
          placeholder="Enter Session Code"
          v-digit="{ maxLength: 6 }"
          size="lg"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-overlay
          :show="busy"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-button
            type="submit"
            size="lg"
            :disabled="busy || otpValid"
            class="btn-bsc"
            >Join Session</b-button
          >
        </b-overlay>
      </b-form-group>
      <p
        id="submissionStatus"
        :class="{
          'text-muted': otpValid == null || busy,
          textRed: otpValid == false,
          textGreen: otpValid,
        }"
      >
        <b-icon
          v-if="showAlert"
          icon="exclamation-circle-Fill"
          font-scale="1.25"
          class="warn-bsc"
        ></b-icon
        >{{ submissionStatus }}
      </p>
    </b-form>
  </div>
</template>

<script>
import ConnectorService from "@/services/ConnectorService.js";

export default {
  name: "Otp",
  computed: {
    otpState() {
      return this.form.otp.length === 6 ? true : false;
    },
  },
  data() {
    return {
      form: {
        otp: "",
      },
      showAlert: true,
      failureMessage: "Not a valid Session Code",
      submissionStatus: " Contact your patient to get a session code",
      busy: false,
      otpValid: null,
    };
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();
      this.showAlert = false;

      this.checkOtpLength();
      const connectorService = new ConnectorService();
      let response = await this.verifyOtp(connectorService);
      if (response == null) {
        return;
      }
      response = await this.establishDataChannel(connectorService);
      if (response == null) {
        return;
      }
      response = await this.establishVideoChannel(connectorService);
      if (response == null) {
        return;
      }
    },

    checkOtpLength() {
      if (!this.otpState) {
        this.otpValid = false;
        this.submissionStatus = "Session Code must be six digits";
        return;
      }
    },

    async verifyOtp(connectorService) {
      try {
        this.busy = true;
        this.submissionStatus = "Verifying Session Code";
        const response = await connectorService.promptOtp(this.form.otp);
        return response;
      } catch (error) {
        this.otpValid = false;
        this.busy = false;
        this.submissionStatus = "Not a valid Session Code - " + error;
        return null;
      }
    },

    async establishDataChannel(connectorService) {
      try {
        this.submissionStatus = "Establishing data channel";
        const response = await connectorService.getDataChannelCredentials();
        return response;
      } catch (error) {
        this.otpValid = false;
        this.busy = false;
        this.submissionStatus = "Could not establish data channel - " + error;
        return null;
      }
    },

    async establishVideoChannel(connectorService) {
      try {
        this.submissionStatus = "Establishing video channel";
        const response = await connectorService.getVideoCredentials();
        this.busy = false;
        this.otpValid = true;
        this.submissionStatus = "Success!";
        connectorService.unregister();
        setTimeout(() => {
          this.$emit("submitSuccess");
        }, 800);
        return response;
      } catch (error) {
        this.otpValid = false;
        this.busy = false;
        this.submissionStatus = "Could not establish video channel - " + error;
        return null;
      }
    },
  },
};
</script>
